export const NuestrosClientesComponents = () => {
    return (
        <>
            <div className="slider-container">
                <div className="slider-track">
                    <div className="slide">
                        <div className='card-clientes shadow-sm' style={{ backgroundColor: "#fff" }}>
                            <div className='image-clientes-card'>
                                <img className="" src={`assets/img/sections/megatiendas.png`} />
                            </div>
                        </div>
                    </div>
                    <div className="slide">
                        <div className='card-clientes shadow-sm' style={{ backgroundColor: "#fff" }}>
                            <div className='image-clientes-card'>
                                <img className="" src={`assets/img/sections/supermu.png`} alt="Supermu" title="Supermu Agroesana" />
                            </div>
                        </div>
                    </div>
                    <div className="slide">
                        <div className='card-clientes shadow-sm' style={{ backgroundColor: "#0f3d0e" }}>
                            <div className='image-clientes-card'>
                                <img className="" src={`assets/img/sections/fastfruit.svg`} alt="FastFruit" title="FastFruit Agroesana" />
                            </div>
                        </div>
                    </div>
                    <div className="slide">
                        <div className='card-clientes shadow-sm' style={{ backgroundColor: "#513685" }}>
                            <div className='image-clientes-card'>
                                <img className="" src={`assets/img/sections/isimo.png`} alt="Isimo" title="Isimo Agroesana" />
                            </div>
                        </div>
                    </div>
                    <div className="slide">
                        <div className='card-clientes shadow-sm' style={{ backgroundColor: "#F4D90C" }}>
                            <div className='image-clientes-card'>
                                <img className="" src={`assets/img/sections/exito.png`} alt="Exito" title="Exito Agroesana" />
                            </div>
                        </div>
                    </div>
                    <div className="slide">
                        <div className='card-clientes shadow-sm' style={{ backgroundColor: "#2DC402" }}>
                            <div className='image-clientes-card'>
                                <img className="rounded-4" src={`assets/img/sections/zapatoca.png`} alt="Zapatoca" title="Zapatoca Agroesana" />
                            </div>
                        </div>
                    </div>
                    <div className="slide">
                        <div className='card-clientes shadow-sm' style={{ backgroundColor: "#fff" }}>
                            <div className='image-clientes-card'>
                                <img className="" src={`assets/img/sections/los-montes.jpg`} alt="Los montes" title="Los montes Agroesana" />
                            </div>
                        </div>
                    </div>
                    <div className="slide">
                        <div className='card-clientes shadow-sm' style={{ backgroundColor: "#0000E3" }}>
                            <div className='image-clientes-card'>
                                <img className="" src={`assets/img/sections/mercamio.svg`} alt="Mercamio" title="Mercamio Agroesana" />
                            </div>
                        </div>
                    </div>
                    <div className="slide">
                        <div className='card-clientes shadow-sm' style={{ backgroundColor: "#fff" }}>
                            <div className='image-clientes-card'>
                                <img className="" src={`assets/img/sections/megatiendas.png`} />
                            </div>
                        </div>
                    </div>
                    <div className="slide">
                        <div className='card-clientes shadow-sm' style={{ backgroundColor: "#fff" }}>
                            <div className='image-clientes-card'>
                                <img className="" src={`assets/img/sections/supermu.png`} alt="Supermu" title="Supermu Agroesana" />
                            </div>
                        </div>
                    </div>
                    <div className="slide">
                        <div className='card-clientes shadow-sm' style={{ backgroundColor: "#0f3d0e" }}>
                            <div className='image-clientes-card'>
                                <img className="" src={`assets/img/sections/fastfruit.svg`} alt="FastFruit" title="FastFruit Agroesana" />
                            </div>
                        </div>
                    </div>
                    <div className="slide">
                        <div className='card-clientes shadow-sm' style={{ backgroundColor: "#513685" }}>
                            <div className='image-clientes-card'>
                                <img className="" src={`assets/img/sections/isimo.png`} alt="Isimo" title="Isimo Agroesana" />
                            </div>
                        </div>
                    </div>
                    <div className="slide">
                        <div className='card-clientes shadow-sm' style={{ backgroundColor: "#F4D90C" }}>
                            <div className='image-clientes-card'>
                                <img className="" src={`assets/img/sections/exito.png`} alt="Exito" title="Exito Agroesana" />
                            </div>
                        </div>
                    </div>
                    <div className="slide">
                        <div className='card-clientes shadow-sm' style={{ backgroundColor: "#2DC402" }}>
                            <div className='image-clientes-card'>
                                <img className="rounded-4" src={`assets/img/sections/zapatoca.png`} alt="Zapatoca" title="Zapatoca Agroesana" />
                            </div>
                        </div>
                    </div>
                    <div className="slide">
                        <div className='card-clientes shadow-sm' style={{ backgroundColor: "#fff" }}>
                            <div className='image-clientes-card'>
                                <img className="" src={`assets/img/sections/los-montes.jpg`} alt="Los montes" title="Los montes Agroesana" />
                            </div>
                        </div>
                    </div>
                    <div className="slide">
                        <div className='card-clientes shadow-sm' style={{ backgroundColor: "#0000E3" }}>
                            <div className='image-clientes-card'>
                                <img className="" src={`assets/img/sections/mercamio.svg`} alt="Mercamio" title="Mercamio Agroesana" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}